<header class="mainHeader">
  <div class="leftSide d-flex">
    <div class="d-flex justify-content-center align-items-center">
      <a [attr.href]="isPingLoggedOut ? null : '/Home'" title="Go to Home" *ngIf="!toShowLabel">
        SyncHPC
        <sub style="font-size: 13px; font-weight: 500">
          {{ synchpcTitle }}
        </sub>
      </a>
      <a href="/" *ngIf="toShowLabel" title="Home">
        <img
          src="../../../assets/images/syncious/logo.png"
          style="width: 4%; height: 4%"
        />
      </a>
      <a href="/" *ngIf="toShowLabel" title="Home" class="me-auto">
        <span style="font-size: x-small">Powered by </span
        ><span style="font-size: small">SyncHPC</span>
      </a>
    </div>
  </div>
  <div
    class="flex-grow-1"
    style="width: 65%; overflow: hidden"
    *ngIf="showNewsFlash"
  >
    <div class="flash-marquee">
      <div class="marquee-content">
        <span *ngFor="let flash of newsFlash" class="flash-item">
          <div class="notification-icon"></div>
          {{ flash }}
        </span>
      </div>
    </div>
  </div>

  <div class="rightSide">
    <!-- Health -->
    <!-- <div class="menu-container"> -->
    <!-- <div class="badge-container" (click)="navigateToHealth()"> -->
    <button
      mat-icon-button
      class="iconBtn"
      title="Health"
      [matMenuTriggerFor]="healthMenu"
      (mouseover)="onMouseEnter()"
      (mouseleave)="onMouseLeave()"
      *ngIf="showHealthIcon == true && toShowTerminal()"
    >
      <i
        [matMenuTriggerFor]="healthMenu"
        (mouseover)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
        class="bi bi-heart-pulse-fill"
      ></i>
      <span class="badge">
        <i
          [ngClass]="getBadgeInfo().icon"
          [ngStyle]="{ color: getBadgeInfo().color, 'font-size': '12px' }"
        ></i>
      </span>
    </button>
    <!-- </div> -->

    <mat-menu #healthMenu="matMenu" xPosition="before" class="healthMenu">
      <div *ngIf="healthData">
        <button
          mat-menu-item
          (click)="onHeartButtonClick(item.component)"
          (mouseleave)="onMouseLeave()"
          (mouseover)="onMouseEnter()"
          *ngFor="let item of healthData"
          [ngClass]="{
            orange: item.health === 'Warning',
            green: item.health === 'OK',
            red: item.health === 'Error'
          }"
        >
          {{ item.component }}: {{ item.health }}&nbsp;&nbsp;
          <span>
            <i
              *ngIf="item.health === 'Error'"
              class="bi bi-x-circle-fill"
              [ngStyle]="{ color: 'red' }"
            ></i>
            <i
              *ngIf="item.health === 'Warning'"
              class="bi bi-exclamation-circle-fill"
              [ngStyle]="{ color: 'orange' }"
            ></i>
            <i
              *ngIf="item.health === 'OK'"
              class="bi bi-check-circle-fill"
              [ngStyle]="{ color: 'green' }"
            ></i>
          </span>
        </button>
      </div>
      <div *ngIf="error">Error fetching health status: {{ error.message }}</div>
    </mat-menu>
    <!-- </div> -->

    <button
      mat-icon-button
      color="accent"
      class="iconBtn"
      (click)="toggleFullScreen()"
      title="Toggle FullScreen"
    >
      <i
        class="bi"
        [ngClass]="fullScreen ? 'bi-fullscreen-exit' : 'bi-arrows-fullscreen'"
      ></i>
    </button>
    <button
      mat-icon-button
      color="accent"
      *ngIf="toShowTerminal()"
      class="iconBtn"
      (click)="openTerminal()"
      title="Open Terminal"
    >
      <i class="bi bi-terminal-fill"></i>
    </button>

    <button
      mat-icon-button
      color="accent"
      class="iconBtn"
      [matMenuTriggerFor]="helpMenu"
      title="Help"
    >
      <i class="bi bi-question-circle-fill"></i>
    </button>
    <mat-menu #helpMenu="matMenu" xPosition="before" class="helpMenu">
      <button mat-menu-item #Support (click)="helpMenuClicked('Support')">
        <i class="bi bi-chat-left-text fs-6 pe-2 helpIcon"></i>
        Contact Support
      </button>
      <button mat-menu-item #Help (click)="helpMenuClicked('Help')">
        <i class="bi bi-question-circle fs-6 pe-2 helpIcon"></i>
        Help
      </button>
      <button mat-menu-item #About (click)="helpMenuClicked('About')">
        <i class="bi bi-info-circle fs-6 pe-2 helpIcon"></i>
        About SyncHPC
      </button>
      <button mat-menu-item #Terms (click)="helpMenuClicked('Terms')">
        <i class="bi bi-check-circle fs-6 pe-2 helpIcon"></i>
        Terms & Conditions
      </button>
      <button mat-menu-item #Privacy (click)="helpMenuClicked('Privacy')">
        <i class="bi bi-shield-exclamation fs-6 pe-2 helpIcon"></i>
        Privacy Policy
      </button>
    </mat-menu>
    <button
      mat-icon-button
      class="iconBtn notificationBtn"
      (click)="open(content)"
      *ngIf="toShow == true"
      triggers="hover"
      ngbTooltip="Notifications"
    >
      <i
        matBadge="{{ badgeCount }}"
        matBadgeColor="warn"
        [matMenuTriggerFor]="notifyMenu"
        #showBadge="matMenuTrigger"
        [matBadgeHidden]="showBadge.menuOpen || badgeCount == 0"
        class="bi bi-bell-fill"
      ></i>
      <div *ngIf="isActionInProgress" class="moving-line"></div>
    </button>

    <button
      mat-icon-button
      *ngIf="toShow == true"
      class="iconBtn userIconButton"
      title="UserProfile"
      [matMenuTriggerFor]="userMenu"
    >
      <i class="bi bi-person-fill"></i>
      <i matSuffix class="bi bi-caret-down-fill" style="font-size: large"></i>
    </button>
    <mat-menu #userMenu="matMenu" xPosition="before" class="userMenu">
      <div class="userInfoContainer">
        <div class="userInfoes" (click)="userMenuClicked($event)">
          <i class="bi bi-person userInfoIcon"></i>
          <p class="property">User :&nbsp;</p>
          <p class="propertyValue">{{ loggedUserName }}</p>
        </div>
        <div
          class="userInfoes"
          *ngIf="
            role.length &&
            !isLicenseExpired &&
            toShowWallet
          "
          (click)="userMenuClicked($event)"
        >
          <i class="bi bi-wallet2 userInfoIcon"></i>
          <p class="property">Wallet :&nbsp;</p>
          <p class="propertyValue">{{ userWalletAmount || "Fetching..." }}</p>
        </div>
        <div
          class="userInfoes"
          *ngIf="needToShowValidity"
          (click)="userMenuClicked($event)"
        >
          <i class="bi bi-calendar userInfoIcon"></i>
          <p class="property">Validity :&nbsp;</p>
          <p class="propertyValue">{{ daysRemaining }} Days</p>
        </div>
        <!-- License Validity End -->
        <div
          class="userInfoes"
          *ngIf="role.length && needToShowRole"
          (click)="userMenuClicked($event)"
        >
          <i class="bi bi-star userInfoIcon"></i>
          <p class="property">Role :&nbsp;</p>
          <p class="propertyValue">{{ role }}</p>
        </div>
        <!--<button type="button" (click)="copyToClipboard()" class="signoutBtn">
          Get Token
        </button>-->
        <hr />
        <button (click)="changeUserPassword()" class="signoutBtn" *ngIf="authType == 0">
          <span
            aria-hidden="true"
            class="bi bi-shield-lock"
            style="margin-right: 5px; cursor: pointer"
          ></span
          >Change Password
        </button>
        <hr *ngIf="authType == 0" />
        <button (click)="logOut()" class="signoutBtn">
          <span
            aria-hidden="true"
            class="bi bi-box-arrow-right"
            style="margin-right: 5px; cursor: pointer"
          ></span
          >Sign Out
        </button>
      </div>
    </mat-menu>
  </div>
</header>

<ng-template #content let-offcanvas>
  <div class="offcanvas-header" style="padding: 8px">
    <div class="d-flex align-items-center flex-grow-1">
      <h4
        class="offcanvas-title"
        id="offcanvas-basic-title"
        style="margin: 0 0.7rem !important"
      >
        Notifications
      </h4>
      <i
        triggers="hover"
        [ngbTooltip]="
          'Only Global Admin have access to clear the notifications or mark them as viewed'
        "
        class="bi bi-info-circle-fill synchpc-primary"
        style="font-size: 1rem; margin-right: 0.7rem"
      >
      </i>
    </div>

    <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
      <button
        type="button"
        title="Clear all the notifications"
        (click)="clearAllNotifications($event)"
        class="btn btn-outline-primary"
      >
        Clear All
      </button>
      <button
        *ngIf="role != 'Reader'"
        type="button"
        class="btn btn-outline-primary manualRefreshNotifications"
        (click)="manualNotificationsRefresh($event)"
      >
        <i class="bi bi-arrow-clockwise"></i>
      </button>
      <button
        *ngIf="role != 'Reader'"
        type="button"
        class="btn btn-outline-primary"
        aria-label="Close"
        (click)="offcanvas.dismiss('Cross click')"
      >
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>
  <hr />

  <div class="offcanvas-body p-0 position-relative">
    @if(notifications.length > 0){
    <div class="notifyDiv">
      <button
        [ngClass]="
          notification.viewed == true
            ? 'notificationBtnAfter'
            : 'notificationBtnBefore'
        "
        style="margin-bottom: 4px"
        *ngFor="let notification of notifications"
      >
        <div class="containerNotification position-relative">
          <div class="icon">
            <i
              title="Notification Type : {{
                notification.type | notificationCheck
              }}"
              class="{{ notification.type }} notifyIcons"
            ></i>
          </div>
          <div
            class="content"
            [ngbTooltip]="notification.content"
            [class.in-progress]="notification.inProgress == true"
            (click)="clickedNotification(notification.id, $event)"
          >
            <div
              *ngIf="notification.inProgress == true"
              class="moving-line-inside-content"
            ></div>
            <b>{{ notification.title }}</b>
            <br />
            <span>{{
              notification.content.length > 70
                ? (notification.content | slice : 0 : 70) + "..."
                : notification.content
            }}</span>
            <div
              [style.color]="
                notification.viewed == true
                  ? 'var(--s-primary-color)'
                  : 'var(--s-primary-color)'
              "
              class="time"
            >
              {{ notification.time }}
            </div>
          </div>
          <div class="removeNotificationBtn">
            <span
              *ngIf="notification.inProgress == false"
              (click)="removeNotification(notification, $event)"
              class="bi bi-x"
            ></span>
          </div>
          <ngx-spinner
            bdColor="rgba(0,0,0,0)"
            size="default"
            zIndex="1"
            type="ball-spin"
            [fullScreen]="true"
            name="notify"
          >
            <p>Please wait ...</p>
          </ngx-spinner>
        </div>
      </button>
    </div>
    } @else {
    <div class="text-center mt-5">
      <p style="color: var(--s-border-color)">No Notifications</p>
    </div>
    }
    <ngx-spinner
      bdColor="rgba(0, 0, 0, 0.1)"
      size="default"
      zIndex="10"
      type="ball-spin"
      [fullScreen]="false"
      color="#0072c6"
      name="notifications"
    >
    </ngx-spinner>
  </div>
</ng-template>
